export enum InvoiceSenderEmailDomains {
	MDVPINC = 'mdvpinc.com',
	ACE_PIPE = 'acepipe.com',
	ROBINSON_PIPE = 'robinsonpipe.com',
	NATIONAL_POWER_RODDING = 'nationalpowerrodding.com',
	BIO_NOMIC = 'bio-nomic.com',
	DEEP_SOUTH_IND = 'deepsouthind.com',
	METENVIRO = 'metenviro.com',
	NIMIN = 'nimin.com',
	NIMMI = 'nimmi.com',
	NATIONAL_PLANT = 'nationalplant.com',
	SPECIALIZED_MAINTENANCE = 'specializedmaintenance.com',
	VIDEOINDUSTRIAL = 'videoindustrial.com',
	ISS_CIPP = 'iss-cipp.com',
	NWMCC = 'nwmcc.com',
	NWMCC_BOS = 'nwmcc-bos.com',
}
